export { VIEW } from '@/components/base-components/components/calendar/index.js';

export const SIZE = Object.freeze({
    LARGE:  'large',
    MEDIUM: 'medium',
    SMALL:  'small',
});

export const TYPE = Object.freeze({
    DEFAULT:       'default',
    PRIMARY:       'primary',
    SECONDARY:     'secondary',
    PRIMARY_OLD:   'primary-old',
    SECONDARY_OLD: 'secondary-old',
    SUCCESS:       'success',
    WARNING:       'warning',
    DANGER:        'danger',
    INFO:          'info',
});

export const MODE = Object.freeze({
    SINGLE:   'single',
    MULTIPLE: 'multiple',
    RANGE:    'range',
});

export const HOURS_FORMAT = Object.freeze({
    HOURS_24: '24',
    HOURS_12: '12',
});
